<template>
  <div>
    <div class="hero-wrapper">
      <el-carousel :interval="5000" trigger="click" arrow="never"
            height="calc(100vh - 80px)" 
            style="text-align: center;" >
        <el-carousel-item >
          <img :src="banner2" class="imgitem"></img>
        </el-carousel-item>
      </el-carousel>
    </div>

    <div class="section-wrapper">
      <div v-for="(cat, index) in productCategories" :key="cat.id" class="section" :class="index % 2 === 0 ? 'section-odd' : 'section-even'">
        <div class="section-inner">
          <div class="section-header">
            <div class="header-icon">
              <i class="header-dot"></i>
            </div>
            <h2 class="section-title">{{ cat.icon }} {{ cat.title }}</h2>
            <p class="section-subtitle">{{ cat.subtitle }}</p>
          </div>
          <p class="section-desc-text">{{ cat.desc }}</p>
          <div class="product-card-grid">
            <router-link v-for="item in cat.items" :key="item" :to="'/product?type=' + cat.id + '&sub=' + encodeURIComponent(item)" class="product-card" :style="{ '--card-color': cat.color, '--card-bg': cat.bg }">
              <span class="card-dot"></span>
              <span>{{ item }}</span>
            </router-link>
          </div>
          <div class="section-more">
            <router-link :to="'/product?type=' + cat.id" class="more-link">了解更多 →</router-link>
          </div>
        </div>
      </div>

      <div class="section section-customer">
        <div class="section-inner">
          <div class="section-header">
            <div class="header-icon">
              <i class="header-dot"></i>
            </div>
            <h2 class="section-title">合作客户</h2>
            <p class="section-subtitle">携手同行，共创价值</p>
          </div>
          <div class="customer-grid">
            <div class="customer-item"><span>海宁农商银行</span></div>
            <div class="customer-item"><span>桐乡农商银行</span></div>
            <div class="customer-item"><span>淳安农商银行</span></div>
            <div class="customer-item"><span>武义农商银行</span></div>
            <div class="customer-item"><span>永康农商银行</span></div>
            <div class="customer-item"><span>磐安农商银行</span></div>
            <div class="customer-item"><span>开化农商银行</span></div>
            <div class="customer-item"><span>江山农商银行</span></div>
            <div class="customer-item"><span>常山农商银行</span></div>
            <div class="customer-item"><span>镇海农商银行</span></div>
            <div class="customer-item"><span>宁海农商银行</span></div>
            <div class="customer-item"><span>盐城人行</span></div>
            <div class="customer-item"><span>射阳农商银行</span></div>
            <div class="customer-item"><span>宝应农商银行</span></div>
            <div class="customer-item"><span>新沂农商银行</span></div>
            <div class="customer-item"><span>宁阳农商银行</span></div>
            <div class="customer-item"><span>泰山农商银行</span></div>
            <div class="customer-item"><span>岱岳农商银行</span></div>
            <div class="customer-item"><span>郓城农商银行</span></div>
            <div class="customer-item"><span>东明农商银行</span></div>
            <div class="customer-item"><span>菏泽农商银行</span></div>
            <div class="customer-item"><span>单县农商银行</span></div>
            <div class="customer-item"><span>成武农商银行</span></div>
            <div class="customer-item"><span>茶陵农商银行</span></div>
            <div class="customer-item"><span>醴陵农商银行</span></div>
            <div class="customer-item"><span>平和农商银行</span></div>
            <div class="customer-item"><span>漳浦农商银行</span></div>
            <div class="customer-item"><span>巴马农商银行</span></div>
            <div class="customer-item"><span>永城农商银行</span></div>
            <div class="customer-item"><span>平定农商银行</span></div>
            <div class="customer-item"><span>晋城农商银行</span></div>
            <div class="customer-item"><span>景德镇农商银行</span></div>
            <div class="customer-item"><span>宜丰农商银行</span></div>
            <div class="customer-item"><span>上高农商银行</span></div>
            <div class="customer-item"><span>高安农商银行</span></div>
            <div class="customer-item"><span>丰城农商银行</span></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  
  export default {
    data() {
      return {
        banner2: require('./banner2.jpg'),
        productCategories: [
          {
            id: 'data',
            icon: '📊',
            title: '数据平台及报表可视化',
            subtitle: '企业数字化转型核心数据底座',
            desc: '打通数据孤岛，构建统一数据资产体系，提供数据治理、调度管控、报表分析、可视化洞察全链路能力，为经营决策与业务创新提供高质量数据支撑。',
            bg: 'linear-gradient(135deg, #eff6ff, #dbeafe)',
            color: '#1a56b8',
            items: ['数据仓库系统', '报表平台及数据可视化系统']
          },
          {
            id: 'crm',
            icon: '👥',
            title: '客户管理及精准营销',
            subtitle: '全渠道获客，精细化运营',
            desc: '覆盖外呼营销、全域营销、私域运营、厅堂营销、普惠走访、商户经营、对公管理、客群分层、权益运营全场景，助力企业实现精准获客、高效转化与客户价值持续增长。',
            bg: 'linear-gradient(135deg, #f0fdf4, #dcfce7)',
            color: '#16a34a',
            items: ['外呼营销管理系统', '营销管理系统', '私域营销系统', '厅堂营销系统', '客户分层分类及精准营销系统', '普惠走访及网格化管理系统', '商户营销管理系统', '企业管理平台（对公客户管理）', '客群管理系统', '客户权益系统']
          },
          {
            id: 'hr',
            icon: '👨‍💼',
            title: '人力资源及绩效考核管理',
            subtitle: '以人为本，赋能组织效能提升',
            desc: '围绕选人、育人、用人、留人体系，从人事档案电子化、流程信息化、行为积分管理、员工画像全周期等维度，构建数字化人力资源管理体系。',
            bg: 'linear-gradient(135deg, #fef3c7, #fde68a)',
            color: '#d97706',
            items: ['人力资源管理系统', '员工行为管理系统', '绩效考核管理系统']
          },
          {
            id: 'credit',
            icon: '💰',
            title: '信贷全流程管理',
            subtitle: '信贷业务全流程数字化管控',
            desc: '覆盖贷前、贷后、不良管理、档案管理、贷款责任制全链路，实现信贷业务规范化、智能化管理，降低信贷风险。',
            bg: 'linear-gradient(135deg, #fce7f3, #fbcfe8)',
            color: '#db2777',
            items: ['贷前管理系统', '贷后管理系统', '不良管理系统', '信贷档案管理系统', '贷款责任制管理系统']
          },
          {
            id: 'workflow',
            icon: '⚙️',
            title: '流程优化及内部管理',
            subtitle: '流程驱动，持续优化管理效能',
            desc: '覆盖数智办公、预算费用、科技管理、物资管理、项目管理全场景，实现流程数字化、管理精益化、运营高效化。',
            bg: 'linear-gradient(135deg, #f0f9ff, #e0f2fe)',
            color: '#0284c7',
            items: ['数智办公管理系统', '预算费用管理系统', '科技管理系统', '物资管理系统', 'PMO管理系统']
          }
        ]
      }
    }
  }
  
</script>

<style lang="less" scoped>
  .imgitem {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  .section-wrapper {
    background: #fff;
  }

  .section {
    .section-inner {
      max-width: 1200px;
      margin: 0 auto;
      padding: 80px 40px;
    }

    .section-header {
      text-align: center;
      margin-bottom: 48px;

      .header-icon {
        margin-bottom: 16px;

        .header-dot {
          display: inline-block;
          width: 10px;
          height: 10px;
          background: #1a56b8;
          border-radius: 50%;
          position: relative;

          &::before,
          &::after {
            content: '';
            position: absolute;
            top: 50%;
            transform: translateY(-50%);
            width: 40px;
            height: 1px;
            background: #d1d5db;
          }

          &::before {
            right: 18px;
          }

          &::after {
            left: 18px;
          }
        }
      }

      .section-title {
        font-size: 32px;
        font-weight: 700;
        color: #111827;
        margin: 0 0 8px 0;
        letter-spacing: 1px;
      }

      .section-subtitle {
        font-size: 16px;
        color: #6b7280;
        margin: 0;
        letter-spacing: 0.5px;
      }
    }

    .section-desc-text {
      font-size: 16px;
      line-height: 1.8;
      color: #6b7280;
      text-align: center;
      max-width: 800px;
      margin: 0 auto 36px;
    }

    .product-card-grid {
      display: grid;
      grid-template-columns: repeat(3, 1fr);
      gap: 16px;
      margin-bottom: 32px;
    }

    .product-card {
      display: flex;
      align-items: center;
      padding: 18px 20px;
      background: #fff;
      border-radius: 12px;
      border: 1px solid #e5e7eb;
      text-decoration: none;
      cursor: pointer;
      transition: all 0.3s ease;
      box-shadow: 0 1px 4px rgba(0, 0, 0, 0.03);

      .card-dot {
        width: 8px;
        height: 8px;
        border-radius: 50%;
        background: var(--card-color, #1a56b8);
        margin-right: 12px;
        flex-shrink: 0;
        transition: transform 0.3s ease;
      }

      span {
        font-size: 14px;
        color: #374151;
        font-weight: 500;
        transition: color 0.3s ease;
      }

      &:hover {
        background: var(--card-bg, #eff6ff);
        border-color: var(--card-color, #1a56b8);
        transform: translateY(-2px);
        box-shadow: 0 6px 20px rgba(0, 0, 0, 0.08);

        .card-dot {
          transform: scale(1.4);
        }

        span {
          color: var(--card-color, #1a56b8);
        }
      }
    }

    .section-more {
      text-align: center;

      .more-link {
        display: inline-block;
        padding: 10px 28px;
        font-size: 15px;
        font-weight: 600;
        color: #1a56b8;
        text-decoration: none;
        border: 1.5px solid #1a56b8;
        border-radius: 24px;
        transition: all 0.3s ease;

        &:hover {
          background: #1a56b8;
          color: #fff;
        }
      }
    }
  }

  .section-odd {
    background: #fff;
  }

  .section-even {
    background: #f8fafc;
  }

  .section-customer {
    background: linear-gradient(180deg, #f0f4f8 0%, #fff 100%);

    .customer-grid {
      display: grid;
      grid-template-columns: repeat(6, 1fr);
      gap: 14px;
      max-width: 1200px;
      margin: 0 auto;

      .customer-item {
        padding: 16px 8px;
        background: #fff;
        border-radius: 10px;
        border: 1px solid #e5e7eb;
        transition: all 0.3s ease;
        cursor: default;
        display: flex;
        align-items: center;
        justify-content: center;

        span {
          font-size: 14px;
          color: #374151;
          font-weight: 500;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }

        &:hover {
          border-color: #1a56b8;
          box-shadow: 0 4px 16px rgba(26, 86, 184, 0.1);
          transform: translateY(-2px);

          span {
            color: #1a56b8;
          }
        }
      }
    }
  }

  @media (max-width: 1024px) {
    .section .product-card-grid {
      grid-template-columns: repeat(2, 1fr);
    }

    .section-customer .customer-grid {
      grid-template-columns: repeat(4, 1fr);
    }
  }

  @media (max-width: 768px) {
    .section .section-inner {
      padding: 48px 20px;
    }

    .section .section-header {
      margin-bottom: 32px;

      .section-title {
        font-size: 24px;
      }
    }

    .section .section-desc-text {
      font-size: 14px;
      margin-bottom: 24px;
    }

    .section .product-card-grid {
      grid-template-columns: repeat(1, 1fr);
      gap: 12px;
    }

    .section-customer .customer-grid {
      grid-template-columns: repeat(3, 1fr);
      gap: 10px;

      .customer-item {
        padding: 12px 6px;

        span {
          font-size: 13px;
        }
      }
    }
  }

  @media (max-width: 480px) {
    .section-customer .customer-grid {
      grid-template-columns: repeat(2, 1fr);
    }
  }
</style>